var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-textarea',{attrs:{"label":"notatka","auto-grow":"","rows":"30"},model:{value:(_vm.facility.note),callback:function ($$v) {_vm.$set(_vm.facility, "note", $$v)},expression:"facility.note"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }